<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item label="运输公司">
              {{ formData.transportCompany || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输日期">
              {{ formData.transportDate || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="送货/进货">
              {{ formData.transportType || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车船号">
              {{ formData.vehicleNumber || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="司机姓名">
              {{ formData.driverName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证">
              {{ formData.driverId || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系方式">
              {{ formData.driverPhone || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="货品">
              {{ formData.goodsName || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数量">
              {{ formData.goodsNum || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型">
              <el-tag v-if="formData.freightType == '1'">一口价</el-tag>
              <el-tag v-if="formData.freightType == '2'">单价</el-tag>
              <span v-if="!formData.freightType">--</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="费用">
              {{ formData.unitPrice || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总价">
              {{ formData.totalPrice || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="创建人">-->
<!--              {{ formData.createUserName || '&#45;&#45;' }}-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12">
            <el-form-item label="创建时间">
              {{ formData.ctime || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结算状态">
              <el-tag v-if="formData.settlementStatus === '1'" type="warning">未结算</el-tag>
              <el-tag v-else-if="formData.settlementStatus === '2'" type="success">已结算</el-tag>
              <span v-else>--</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'freightRecordDetail',
  data() {
    return {
      formData: {
        freightId: '',
        transportCompany: '',
        transportDate: '',
        transportType: '',
        vehicleNumber: '',
        driverName: '',
        driverId: '',
        driverPhone: '',
        goodsName: '',
        goodsNum: '',
        freightType: '',
        unitPrice: '',
        totalPrice: '',
        settlementStatus: '',
        createUserName: '',
        ctime: ''
      },
      loading: false
    }
  },
  created() {
    if (this.freightId) {
      this.loadData()
    }
  },
  computed: {
    freightId() {
      return this.$route.query.freightId
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.wlFreight.selectWlFreightByFreightId, {
          params: { freightId: this.freightId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
